module.exports = __webpack_public_path__ + "media/images/hello_drifter_logo_line_wht-126b24e8462c2e684223717e5a6615e2.png";